import React from 'react';
import PropTypes from 'prop-types';
import ShareSucc from './shareSucc';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import { QQShare } from 'ThreeTerminal_mobile_dynamic';

class TwiceShare extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isShowFixed: false,
    };

    componentDidMount() {
        if (window.wxShareConfig && window.wxShareTool && window.wxShareTool.on) {
            window.wxShareTool.on('wxShareEvent', () => {
                this.setState({
                    isShowFixed: true,
                });
            });
        }
    }

    changeShow = () => {
        this.setState({
            isShowFixed: false,
        });
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { isShowFixed } = this.state;
        // const qqShareCofig = {
        //     title: content.title,
        //     img:
        //         (content.thumbnails &&
        //             content.thumbnails.image &&
        //             content.thumbnails.image[0] &&
        //             content.thumbnails.image[0].url) ||
        //         'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg',
        //     desc: content.summary || content.title || '',
        //     cb: () => {
        //         this.setState({
        //             isShowFixed: true,
        //         });
        //     },
        // };

        return (
            <React.Fragment>
                {/* <QQShare content={qqShareCofig} /> */}
                {isShowFixed && <ShareSucc content={content} change={this.changeShow} />}
            </React.Fragment>
        );
    }
}

export default errorBoundary(TwiceShare);
